import { getCorporateAccountFaqsList } from "../../../app/api/getFaqsList";
import { BaseAction } from "../../../core/actions/BaseAction";
import { updateRecoilState } from "../../../Orchestrator/Recoils/Events/Recoil";
import { IApiResponse } from "../../../Orchestrator/Types/Index";
import {
  IFaqResponse,
  IGetFaqListActionParams,
} from "../../../Orchestrator/Types/Interface/INeedHelp";

class GetCorporateAccountFaqsAction extends BaseAction<
  IFaqResponse,
  IGetFaqListActionParams
> {
  override async run(): Promise<IFaqResponse | null> {
    let faqResponse: IFaqResponse | null = null;
    let { intl } = this.params!;

    try {
      updateRecoilState("selectFaqLoading", true);
      const response: IApiResponse<IFaqResponse> = await getCorporateAccountFaqsList(intl);
      if (response.status === "ok" && response.answer) {
        const data = response.answer;
        if (data) {
          faqResponse = data;          
          updateRecoilState("selectCorporateAccountFaqAtom", faqResponse.data);
        } else {
          console.error("No FAQ data available.");
        }
      } else {
        console.error("Failed to fetch FAQ data.");
      }
    } catch (error: any) {
      console.error("Error fetching FAQ data:", error);
    } finally {
      updateRecoilState("selectFaqLoading", false);
      return faqResponse;
    }
  }
}

export const getCorporateAccountFaqsAction = new GetCorporateAccountFaqsAction();
